import { useForm } from "react-hook-form";
import { useState } from "react";
import { useMutation } from "@apollo/client";
import { REPORT_ABUSE } from "../../../../apollo-client/mutations";
import { useReportStore } from "../../../../store/reportStore";

export const useReportForm = (setActiveStep) => {
  const { reportState, closeReport } = useReportStore();
  const { contentId, contentType } = reportState;
  const [submitError, setSubmitError] = useState(null);

  // Form state
  const form = useForm({
    defaultValues: {
      category: "",
      subcategory: "",
      description: "",
    },
  });

  const { control, handleSubmit, watch, reset, formState: { errors, isSubmitting } } = form;

  // Watch form values
  const watchedCategory = watch("category");
  const watchedSubcategory = watch("subcategory");
  const watchedDescription = watch("description");

  // Mutation
  const [reportAbuse, { loading: isSubmittingReport }] = useMutation(REPORT_ABUSE, {
    variables: {
      contentId,
      contentType,
      reason: watchedCategory,
      subreason: watchedSubcategory,
      description: watchedDescription,
    },
    onCompleted: () => {
      setSubmitError(null);
    },
  });

  const onSubmit = async (data) => {
    console.log("submitting");
    try {
      await reportAbuse();
    } catch (error) {
      setSubmitError(error.message);
      throw error; // Re-throw the error so handleSubmitAndAdvance can catch it
    }
  };

  const handleCancel = () => {
    reset();
    setSubmitError(null);
    if (setActiveStep) {
      setActiveStep(0);
    }
    closeReport();
  };


  return {
    form,
    control,
    handleSubmit,
    watch,
    reset,
    errors,
    isSubmitting,
    watchedCategory,
    watchedSubcategory,
    watchedDescription,
    submitError,
    setSubmitError,
    isSubmittingReport,
    onSubmit,
    handleCancel,
  };
};
